// Expenses Reducer
const labelsReducerDefaultState = [];

export default (state = labelsReducerDefaultState, action) => {
    switch (action.type) {
        case 'SET_LABELS':
            return action.labels

        case 'ADD_LABEL':
            return [
                ...state,
                action.label
            ];
        case 'REMOVE_LABEL':
            return state.filter(({ id }) => id !== action.id);
        case 'EDIT_LABEL':
            return state.map((label) => {
                if (label.id === action.id) {
                    return {
                        ...label,
                        ...action.updates
                    };
                } else {
                    return label;
                };
            });
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/labels.js